import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const normalizeRole = (role) => {
  switch (role) {
    case 'job_seeker':
      return 'jobseeker';
    case 'service_provider':
      return 'serviceprovider';
    default:
      return role || 'general';
  }
};

const ProfileRedirect = () => {
  const { currentUser, userRole } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const role = normalizeRole(userRole);

  switch (role) {
    case 'jobseeker':
      return <Navigate to="/jobseeker/profile" replace />;
    case 'employer':
      return <Navigate to="/employer/profile" replace />;
    case 'serviceprovider':
      return <Navigate to="/service-provider/profile" replace />;
    case 'admin':
      return <Navigate to="/admin" replace />;
    default:
      return <Navigate to="/profile" replace />;
  }
};

export default ProfileRedirect;